export default {
    categories: {
        opportunity: {
            title: window.i18n.__('Opportunité'),
            subtitle: window.i18n.__('Données opportunité'),
        },
    },
    rows: [
        {
            category: 'opportunity',
            label: window.i18n.__('ID opportunité'),
            description: {
                text: window.i18n.__('Identifiant unique provenant d’un export Sellsy'),
                subtext: window.i18n.__('Utile uniquement en cas de mise à jour'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Numérique'),
            },
        },
        {
            category: 'opportunity',
            label: window.i18n.__('Nom d’Opportunité'),
            description: {
                text: window.i18n.__('Nom de l’opportunité'),
            },
            mandatory: true,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'opportunity',
            label: window.i18n.__('Identifiant Opportunité'),
            description: {
                text: window.i18n.__('Identifiant de l’opportunité'),
                subtext: window.i18n.__('Exemple : OPP-00027'),
            },
            mandatory: false,
            mandatoryTooltip: window.i18n.__(
                'Ce champ devient obligatoire s’il est choisi en critère de comparaison.',
            ),
            mandatoryTooltipClass: 'w-240',
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'opportunity',
            label: window.i18n.__('Nom Client / Prospect'),
            description: {
                text: window.i18n.__(
                    'Doit obligatoirement correspondre au nom de la société auquel vous souhaitez l’attacher. Dans le cas d’un particulier, il faut indiquer la civilité, le nom et le prénom (M Jean Dupont)',
                ),
            },
            mandatory: true,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'opportunity',
            label: window.i18n.__('ID Client / Prospect'),
            description: {
                text: window.i18n.__('Identifiant unique provenant d’un export Sellsy'),
                subtext: window.i18n.__('Utile uniquement en cas de mise à jour'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Numérique'),
            },
        },
        {
            category: 'opportunity',
            label: window.i18n.__('Type Société'),
            description: {
                text: window.i18n.__('Type'),
            },
            mandatory: false,
            mandatoryTooltip: window.i18n.__(
                'Ce champ devient obligatoire si le champ \n Nom Client / Prospect est renseigné',
            ),
            value: {
                text: window.i18n.__('"Client" ou "Prospect"'),
            },
        },
        {
            category: 'opportunity',
            label: window.i18n.__('Statut'),
            description: {
                text: window.i18n.__('Statut de l’opportunité'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Valeur parmi la liste existante'),
                subtext: window.i18n.__('Une seule valeur possible'),
            },
            valueFrom: {
                source: 'statuses',
                modalName: window.i18n.__('Afficher toutes les valeurs des statuts'),
                maxDisplay: 9,
            },
        },
        {
            category: 'opportunity',
            label: window.i18n.__('Date de création'),
            description: {
                text: window.i18n.__('Date de création de l’opportunité'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Date'),
                subtext: window.i18n.__('jj/mm/aaaa'),
            },
        },
        {
            category: 'opportunity',
            label: window.i18n.__('Pipeline'),
            description: {
                text: window.i18n.__('Nom du pipeline dans lequel se trouve l’opportunité'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Valeur parmi la liste existante'),
                subtext: window.i18n.__('Une seule valeur possible'),
            },
            valueFrom: {
                source: 'pipelines',
                modalName: window.i18n.__('Afficher tous les pipelines'),
                maxDisplay: 9,
            },
        },
        {
            category: 'opportunity',
            label: window.i18n.__('Étape'),
            description: {
                text: window.i18n.__('Étape du pipeline dans lequel se trouve l’opportunité'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Valeur parmi la liste existante'),
                subtext: window.i18n.__('Une seule valeur possible'),
            },
            valueFrom: {
                source: 'steps',
                modalName: window.i18n.__('Afficher toutes les étapes des pipelines'),
                modalLabelGroupSuffix: window.i18n.__('Pipeline'),
                forceFullList: true,
            },
        },
        {
            category: 'opportunity',
            label: window.i18n.__('Date d’échéance'),
            description: {
                text: window.i18n.__('Date d’échéance de l’opportunité'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Date'),
                subtext: window.i18n.__('jj/mm/aaaa'),
            },
        },
        {
            category: 'opportunity',
            label: window.i18n.__('Probabilité'),
            description: {
                text: window.i18n.__('Valeur numérique entre 0 et 100'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Numérique'),
            },
        },
        {
            category: 'opportunity',
            label: window.i18n.__('Montant potentiel'),
            description: {
                text: window.i18n.__('Montant potentiel de l’opportunité'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Numérique'),
            },
        },
        {
            category: 'opportunity',
            label: window.i18n.__('Collaborateurs affectés'),
            description: {
                text: window.i18n.__('Collaborateurs affectés à l’opportunité'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Nom complet des collaborateurs'),
                subtext: window.i18n.__('Valeurs à séparer par une virgule'),
            },
            valueFrom: {
                source: 'staffs',
                modalName: window.i18n.__('Afficher tous les collaborateurs affectés'),
                maxDisplay: 9,
            },
        },
        {
            category: 'opportunity',
            label: window.i18n.__('Source'),
            description: {
                text: window.i18n.__('Source de l’opportunité'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Valeur parmi la liste existante'),
                subtext: window.i18n.__('Une seule valeur possible, par défaut : "Interne"'),
            },
            valueFrom: {
                source: 'sources',
                modalName: window.i18n.__('Afficher toutes les sources'),
                maxDisplay: 9,
            },
        },
        {
            category: 'opportunity',
            label: window.i18n.__('Note'),
            description: {
                text: window.i18n.__('Note liée à l’opportunité'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'opportunity',
            label: window.i18n.__('Smart-tags'),
            description: {
                text: window.i18n.__('Liste de smart-tags'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
                subtext: window.i18n.__('À séparer par une virgule'),
            },
        },
    ],
};
